export enum DanceManagerUserInviteTokenExpirationTimeEnum {
  TWO_HOURS = 'TWO_HOURS',
  ONE_WEEK = 'ONE_WEEK',
  TWO_WEEKS = 'TWO_WEEKS'
}
